import { getCustomersRestricted } from 'api/CustomersApi';
import { AccordionBodyItem } from 'component/Accordion';
import { SelectComponent } from 'component/Select';
import { React, useEffect, useState } from 'react';
import { useUser } from 'routes/UserContext';
import { axiosWrapper } from 'utils/Helper';

export const TaskCustomer = (props) => {
  const [options, setOptions] = useState([]);
  const { user } = useUser();
  const formValue = props.formData?.info?.general?.task_customer ?? props.formData?.task_customer;

  useEffect(() => {
    axiosWrapper(() => {
      getCustomersRestricted()
        .then((res) => {
          const data = res.data?.results ?? res.data ?? [];
          const list = Array.isArray(data) ? data : [];
          setOptions(
            list.map((item) => ({
              value: item.id,
              label: item.name,
            }))
          );
        })
        .catch((err) => {
          console.error(err);
        });
    });
  }, []);

  useEffect(() => {
    const hasSelectedValue = formValue !== null && formValue !== undefined && formValue !== '';
    if (hasSelectedValue || !user?.default_customer || !options.length) return;

    const defaultId = user.default_customer?.id ?? user.default_customer;
    const hasDefaultInOptions = options.some((item) => String(item.value) === String(defaultId));
    if (defaultId && hasDefaultInOptions && props.setFormData) {
      props.setFormData((prev) => {
        const prevInfo = prev?.info || {};
        const prevGeneral = prevInfo.general || {};
        if (prev?.info?.general) {
          return {
            ...prev,
            info: {
              ...prevInfo,
              general: { ...prevGeneral, task_customer: defaultId },
            },
            task_customer: defaultId,
          };
        }
        return {
          ...prev,
          task_customer: defaultId,
        };
      });
    }
  }, [formValue, user?.default_customer, options, props.setFormData]);

  const handleTaskCustomer = (value) => {
    const id = value?.value ?? value;
    if (props.formData?.info?.general !== undefined) {
      props.setFormData((prev) => ({
        ...prev,
        info: {
          ...prev.info,
          general: {
            ...prev.info.general,
            task_customer: id,
          },
        },
        task_customer: id,
      }));
    } else {
      props.setFormData((prev) => ({
        ...prev,
        task_customer: id,
      }));
    }
  };

  const valueId = formValue?.value ?? formValue;

  return (
    <AccordionBodyItem
      accordionSubId={
        <div>
          {props.subId && <span>{props.subId}</span>}
          {props.subId && <span className="star">*</span>}
          {!props.subId && <span />}
        </div>
      }
      titleUA="Замовник задачі"
      titleEN="Task customer"
      className={props.errors?.includes?.('task_customer') ? 'error error-text' : ''}
      children={
        <div className="flex-group no-wrap">
          <SelectComponent
            isMulti={false}
            value={
              valueId
                ? {
                    value: options.find((option) => option.value === valueId)?.value ?? valueId,
                    label: options.find((option) => option.value === valueId)?.label ?? '',
                  }
                : null
            }
            handleSelect={handleTaskCustomer}
            options={options}
            placeholder="Select"
            isSearchable
          />
        </div>
      }
    />
  );
};
